
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/products/new",
      function () {
        return require("private-next-pages/admin/products/new.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/products/new"])
      });
    }
  